import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import AdminLayout from '@app/layout/AdminLayout.tsx';
import SecurityUsage from '@components/admin/security/SecurityUsage.tsx';

interface ComponentProps {}

const SecurityUsagePage: React.FC<ComponentProps> = () => {
  return (
    <AdminLayout title={'Security usage'}>
      <SecurityUsage />
    </AdminLayout>
  );
};

export default withAuthenticationRequired(SecurityUsagePage);